import localeUtils from 'utils/LanguageLocale';

// Activity type codes
export const ACTIVITY_TYPE_CODE = {
    GAME_POINT_CREDIT: 'GAME_POINT_CREDIT',
    GAME_POINT_DEBIT: 'GAME_POINT_DEBIT'
};

// Beauty Insider activity icon sources
export const ACTIVITY_ICON_SRC = {
    cashApplied: '/img/ufe/icons/points-cash.svg',
    gamification: '/img/ufe/bi-gamification-icon.svg'
};

export const isActivityGroupingEnabled = () => {
    if (localeUtils.isCanada()) {
        return Sephora.configurationSettings.loyalty?.enableCreativeRefreshP1_CA;
    }

    return Sephora.configurationSettings.loyalty?.enableCreativeRefreshP1_US;
};


// Gamification Activity (BI Challenge)
export const isGamificationActivity = activityTypeCode => {
    return activityTypeCode === ACTIVITY_TYPE_CODE.GAME_POINT_CREDIT || activityTypeCode === ACTIVITY_TYPE_CODE.GAME_POINT_DEBIT;
};

